import { Association } from '../Association/Association';
export class AssociateItems {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get question() {
        return this.parent;
    }
    getAssociationByLegacyId(legacyId) {
        return this.question.associateStore.allAssociations.find(association => association.associateLegacyId === legacyId);
    }
    getAssociationByPlace(place) {
        return this.question.associateStore.allAssociations.find(association => association.place === place);
    }
    getEnsuredAssociationByPlace(place) {
        const existingAssociation = this.getAssociationByPlace(place);
        if (existingAssociation)
            return existingAssociation;
        const newAssociation = Association.fromSerialized({ place, type: 'association', parent: this.question });
        this.question.allAssociations.push(newAssociation);
        return newAssociation;
    }
}
